export const iconFontAwesomeEmojiFaceLaughBeam = (
	<i className="fa-solid fa-face-laugh-beam"></i>
);
